import React, { useEffect, useState } from 'react';
import { Grid, Avatar, Typography, Slide, Box, Skeleton } from '@mui/material';
import SwipeableGrid from './SwipeableGrid';
import NewsCarousel from './NewsCarousel';
import Birthday from './Birthday';
import WorkAnniversary from './WorkAnniversary';
import NewsJoinees from './NewJoinees';
import GplRegistrationForm from './GplRegistrationForm';
import { fetchRegistrationWindow } from '../gplApi';
import gplIcon from './gplLogo.png';
import storyImg from './story.png';
import trendingImg from './trendingImg.png';
import WorkAnniversaryIcon from '../../../assets/Gifs/workAnniversaryIcon.png';
import CakeIcon from '../../../assets/Gifs/cake.png';
import NewJoineesIcon from '../../../assets/Gifs/NewJoinees.png';
import NewOpenings from '../../../assets/Gifs/we-are-hiring.png';
// import NewOpenings from '../../../assets/Gifs/referral.gif';
import NewOpeningsCarousel from './NewOpeningsCarousel';

const storyIconByName = {
  GPL: gplIcon,
  Featured: storyImg,
  Trending: trendingImg,
  Twinwin: NewOpenings,
  Birthdays: CakeIcon,
  Anniversaries: WorkAnniversaryIcon,
  Joinees: NewJoineesIcon,
};

const GnnStories = ({
  isSm,
  isTopCarouselOpen,
  handleOpenTopCarousel,
  handleCloseTopCarousel,
  topNews,
  isTopNewsLoading,
  isTopError,
  isTrendingCarouselOpen,
  handleOpenTrendingCarousel,
  handleCloseTrendingCarousel,
  trendingNews,
  isTrendingLoading,
  isTrendingError,
  isBirthdayCarouselOpen,
  handleOpenBirthdayCarousel,
  handleCloseBirthdayCarousel,
  isWorkAnniversariesCarouselOpen,
  handleOpenWorkAnniversariesCarousel,
  handleCloseWorkAnniversariesCarousel,
  isNewJoineesCarouselOpen,
  handleOpenNewJoineesCarousel,
  handleCloseNewJoineesCarousel,
  newOpenings,
  isNewOpeningsDataLoading,
  isNewOpeningsDataError,
  isNewOpeningsCarouselOpen,
  handleOpenNewOpeningsCarousel,
  handleCloseNewOpeningsCarousel,
  setNewOpeningsCarouselOpen,
  isGplCarouselOpen,
  handleOpenGplCarousel,
  handleCloseGplCarousel,
}) => {
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [currentIndividualIndex, setCurrentIndividualIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState({});
  const isAnyCarouselLoading =
  isTopNewsLoading || isTrendingLoading || isNewOpeningsDataLoading;

  // The GPL story is only worth offering while the auction is actually taking
  // registrations - otherwise tapping it just lands on the form's "warming up" screen.
  // `open` is the master switch the form itself checks; the per-gender flags are left to
  // the form, which can explain to a player why their own auction is shut.
  //
  // Starts hidden and is only revealed on an explicit `open: true`, so neither the
  // in-flight moment nor a failed call flashes an icon that leads nowhere.
  const [isGplRegistrationOpen, setGplRegistrationOpen] = useState(false);

  useEffect(() => {
    let isCurrent = true;

    fetchRegistrationWindow()
      .then((data) => {
        if (isCurrent) setGplRegistrationOpen(data?.open === true);
      })
      .catch(() => {
        // The GPL API is a separate service - if it cannot answer, leave the story out
        // rather than blocking or breaking the rest of the row.
        if (isCurrent) setGplRegistrationOpen(false);
      });

    return () => {
      isCurrent = false;
    };
  }, []);

  const handleImageLoad = (index) => {
    setImagesLoaded(prev => ({
      ...prev,
      [index]: true
    }));
  };

  const carousels = [
    {
      name: 'GPL',
      icon: (
        <Avatar
          src={gplIcon}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
            backgroundColor: 'white',
            img: { objectFit: 'contain' },
          }}
        />
      ),
      open: isGplCarouselOpen,
      onOpen: handleOpenGplCarousel,
      onClose: handleCloseGplCarousel,
      content: <GplRegistrationForm />,
      // Kept in the array even when hidden: `currentIndex` and the swipe handlers address
      // carousels by position, so dropping the entry would shift every other story's index.
      hidden: !isGplRegistrationOpen,
    },
    {
      name: 'Featured',
      icon: (
        <Avatar
          src={storyImg}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isTopCarouselOpen,
      onOpen: handleOpenTopCarousel,
      onClose: handleCloseTopCarousel,
      content: (
        <NewsCarousel
          topNews={topNews}
          isLoading={isTopNewsLoading}
          isError={isTopError}
          isTopNews={true}
          currentIndex={currentIndividualIndex}
          setCurrentIndex={setCurrentIndividualIndex}
        />
      ),
    },
    {
      name: 'Trending',
      icon: (
        <Avatar
          src={trendingImg}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
            border: '1px solid grey',
          }}
        />
      ),
      open: isTrendingCarouselOpen,
      onOpen: handleOpenTrendingCarousel,
      onClose: handleCloseTrendingCarousel,
      content: (
        <NewsCarousel
          topNews={trendingNews}
          isLoading={isTrendingLoading}
          isError={isTrendingError}
          currentIndex={currentIndividualIndex}
          setCurrentIndex={setCurrentIndividualIndex}
        />
      ),
    },

     {
      name: 'Twinwin',
      icon: (
        <Avatar
          src={NewOpenings}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isNewOpeningsCarouselOpen,
      onOpen: handleOpenNewOpeningsCarousel,
      onClose: handleCloseNewOpeningsCarousel,
      content: (
        <NewOpeningsCarousel
          newOpenings={newOpenings}
          currentIndex={currentIndividualIndex}
          setCurrentIndex={setCurrentIndividualIndex}
          isLoading={isNewOpeningsDataLoading}
          isError={isNewOpeningsDataError}
        />
      ),
    },
    {
      name: 'Birthdays',
      icon: (
        <Avatar
          src={CakeIcon}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isBirthdayCarouselOpen,
      onOpen: handleOpenBirthdayCarousel,
      onClose: handleCloseBirthdayCarousel,
      content: <Birthday />,
    },
    {
      name: 'Anniversaries',
      icon: (
        <Avatar
          src={WorkAnniversaryIcon}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isWorkAnniversariesCarouselOpen,
      onOpen: handleOpenWorkAnniversariesCarousel,
      onClose: handleCloseWorkAnniversariesCarousel,
      content: <WorkAnniversary />,
    },
    {
      name: 'Joinees',
      icon: (
        <Avatar
          src={NewJoineesIcon}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isNewJoineesCarouselOpen,
      onOpen: handleOpenNewJoineesCarousel,
      onClose: handleCloseNewJoineesCarousel,
      content: <NewsJoinees />,
    },
  ];

  // Step to the next/previous story that is actually on show, and stay put at the ends -
  // a hidden entry still occupies its index, so plain +1/-1 would open it.
  const handleSwipeRight = () => {
    setCurrentIndex((prevIndex) => {
      const next = carousels.findIndex((carousel, index) => index > prevIndex && !carousel.hidden);
      return next === -1 ? prevIndex : next;
    });
  };

  const handleSwipeLeft = () => {
    setCurrentIndex((prevIndex) => {
      for (let index = prevIndex - 1; index >= 0; index -= 1) {
        if (!carousels[index].hidden) return index;
      }
      return prevIndex;
    });
  };

  const handleSwipeUp = () => {
    carousels[currentIndex].onClose();
    setCurrentIndex(-1);
  };

  const generateConicGradient = (numItems, mainColor, separatorColor) => {
    const whiteSegmentSize = 2; // Size of white segment in percentage
    const totalWhiteSize = whiteSegmentSize * numItems; // Total size of all white segments
    const mainSegmentSize = (100 - totalWhiteSize) / numItems; // Size of each main segment

    let gradientStops = '';

    for (let i = 0; i < numItems; i++) {
      const startMain = i * (mainSegmentSize + whiteSegmentSize); // Start of the main segment
      const endMain = startMain + mainSegmentSize; // End of the main segment
      const startWhite = endMain; // Start of the white segment
      const endWhite = startWhite + whiteSegmentSize; // End of the white segment

      gradientStops += `${mainColor} ${startMain}% ${endMain}%, ${separatorColor} ${startWhite}% ${endWhite}%`;
      if (i < numItems - 1) gradientStops += ', ';
    }

    return `conic-gradient(${gradientStops})`;
  };

  return (
    <Slide direction="right" in={true} timeout={500} mountOnEnter unmountOnExit>
      <Grid
        sx={{
          mt: 1,
          mb: 1,
          gap: 1,
          overflowX: 'auto',
          width: '100%',
          display: 'flex',
          flexWrap: 'nowrap',
        }}
      >
        {isAnyCarouselLoading ? (
        // Show 5 avatar skeletons
        Array.from({ length: 5 }).map((_, index) => (
          <Box key={index} sx={{ textAlign: 'center' }}>
            <Skeleton
              variant="circular"
              animation="wave"
              sx={{
                height: { xs: '60px', sm: '80px', md: '100px' },
                width: { xs: '60px', sm: '80px', md: '100px' },
              }}
            />
            <Skeleton
              width={60}
              height={20}
              sx={{
                mx: 'auto',
                mt: 1,
                display: { xs: 'block', sm: 'none' },
              }}
            />
            <Skeleton
              width={80}
              height={24}
              sx={{
                mx: 'auto',
                mt: 1,
                display: { xs: 'none', sm: 'block', md: 'none' },
              }}
            />
            <Skeleton
              width={100}
              height={28}
              sx={{
                mx: 'auto',
                mt: 1,
                display: { xs: 'none', md: 'block' },
              }}
            />
          </Box>
        ))
      ) : (
        // Original carousel grid here
        <>
        {carousels.map(
          (carousel, index) =>
            index === currentIndex &&
            !carousel.hidden && (
              <SwipeableGrid
                key={index}
                isSm={isSm}
                handleSwipeLeft={handleSwipeLeft}
                handleSwipeRight={handleSwipeRight}
                topNews={topNews}
                trendingNews={trendingNews}
                storyLength={carousel.name === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1}
                handleSwipeUp={handleSwipeUp}
                // handleSwipeDown={handleSwipeDown}
                // handleSwipeDown={() => handleSwipeDown(newsItems[currentIndividualIndex].id)}
                carouselName={carousel.name}
                carouselIcon={carousel.icon}
                currentIndex={currentIndividualIndex}
                setCurrentIndex={setCurrentIndividualIndex}
                iterableData={
                  carousel.name === 'Featured'
                    ? topNews
                    : carousel.name === 'Trending'
                    ? trendingNews
                    : newOpenings
                }
                isLoading={carousel.name === 'Featured'
                    ? isTopNewsLoading
                    : carousel.name === 'Trending'
                    ? isTrendingLoading
                    : isNewOpeningsDataLoading}
              >
                {carousel.content}
              </SwipeableGrid>
            )
        )}

        {carousels.map(
          (carousel, index) =>
            index !== currentIndex &&
            !carousel.hidden && (
              <Grid
                key={index}
                item
                onClick={() => {
                  carousel.onOpen();
                  setCurrentIndex(index);
                }}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'default',
                  '&:hover': { opacity: 0.8 },
                }}
              >
                <Box
                  sx={{
                    display: 'inline-block',
                    borderRadius: '50%',
                    padding: '1px',
                    background: imagesLoaded[index] ? (
                      carousel.name === 'Featured'
                        ? generateConicGradient(topNews?.length || 0, 'purple', 'white')
                        : carousel.name === 'Trending'
                        ? generateConicGradient(trendingNews?.length || 0, 'purple', 'white')
                        : 'linear-gradient(to right, purple, orange, blue)'
                    ) : 'transparent',
                  }}
                >
                  {!imagesLoaded[index] ? (
                    <Skeleton 
                      variant="circular"
                      sx={{
                        height: { xs: '60px', sm: '80px', md: '100px' },
                        width: { xs: '60px', sm: '80px', md: '100px' },
                      }}
                      animation="wave"
                    />
                  ) : null}
                  <Avatar
                    variant="round"
                    src={storyIconByName[carousel.name]}
                    sx={{
                      height: { xs: '60px', sm: '80px', md: '100px' },
                      width: { xs: '60px', sm: '80px', md: '100px' },
                      borderRadius: '50%',
                      border: '0px solid white',
                      display: imagesLoaded[index] ? 'block' : 'none',
                      // The GPL logo is a square badge, so contain it inside the circle
                      // instead of letting the default cover crop the bat arcs off.
                      ...(carousel.name === 'GPL'
                        ? { backgroundColor: 'white', img: { objectFit: 'contain', p: '2px' } }
                        : {}),
                    }}
                    onLoad={() => handleImageLoad(index)}
                  />
                </Box>

                <Typography sx={{ mt: 1, fontSize: { xs: '0.7rem', sm: '0.9rem', md: '1.2rem' }, textAlign: 'center' }}>
                  {carousel.name}
                </Typography>
                {/* )} */}
              </Grid>
            )
        )}
        </>
      )}
      </Grid>
    </Slide>
  );
};

export default GnnStories;
